import React from 'react'
import myImage from '../../images/jupor2.webp'
import "./Second.css"
function Second() {
  return (
    <div style={{    overflowX: "hidden"}}>
      <div className='row'>
        <div className='col-lg-6 col-md-6 '>
        <section className='gc1' style={{backgroundImage: `url(${myImage})`}}>
        
        </section>
        </div>
        <div className='col-lg-6 col-md-6 '>
             <div className='gc2 container'>
                <h1 className='gc3 text-center'>Convene Yourself</h1>
                <h3 className='gc4 text-center'>We will be here for you every step of the way. Our education consultants will work with you and your family to plan the next step on your educational journey.</h3>
             </div>
        </div>
      </div>
    </div>
  )
}

export default Second
